// src/hooks/use-page-fab.ts
import { useEffect, useRef } from "react";
import { useFab, type FabAction } from "@/components/navigation/fab-context";

export function usePageFab(action: FabAction | null) {
    const { setAction } = useFab();
    
    // Use a ref to store the action to avoid dependency issues
    const actionRef = useRef<FabAction | null>(null);
    
    // Update the ref with the latest action
    actionRef.current = action;

    useEffect(() => {
        // Set the FAB action when the component mounts
        setAction(action);

        // Clear the FAB action when the component unmounts
        return () => setAction(null);
    }, [setAction]); // Only depend on setAction, not the action object
}
